import React, { useEffect, useState } from "react";
import "../component/style.css";
import SideNav from "../component/sideNav";
import Header from "../component/header";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { UserApi } from "../apis";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InsightsIcon from "@mui/icons-material/Insights";
import EditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Grid from "@mui/material/Grid2";
import CustomInput from "../component/customInput";
import CustomInputLabel from "../component/customInputLabel";
import { useSelector } from "react-redux";

const Designer = () => {
  const conUser = useSelector((state) => state?.conUser);
  const [Designers, setDesigners] = useState([]);
  const [paginator, setPaginator] = useState({
    page: 0,
    perPage: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const DesignerRouter = UserApi();

  // Attributes
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [profileImg, setProfileImg] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  //Err Attributes
  const [nameErr, setNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [phoneErr, setPhoneErr] = useState("");

  const columns = [
    {
      field: "name",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Name
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.value,
      sortable: false,
    },
    {
      field: "email",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Email
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.email,
      sortable: false,
    },
    {
      field: "phone",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Phone Number
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.phone,
      sortable: false,
    },
    {
      field: "companyName",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Company Name
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => row.company_id?.name,
      sortable: false,
    },
    {
      field: "updatedAt",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Updated At
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => {
        const dateString = row?.updatedAt;
        if (!dateString) return "";
        const dateObject = new Date(dateString);
        const formattedDate = dateObject.toISOString().split("T")[0];

        return formattedDate;
      },
      sortable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      getActions: ({ row }) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Detail" placement="top">
              <InsightsIcon style={{ color: "green", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Detail"
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Edit" placement="top">
              <EditIcon style={{ color: "#27326A", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Edit"
          onClick={() => {
            setSelectedRecord(row);
            setName(row?.name);
            setEmail(row?.email);
            setPhone(row?.phone);
            setProfileImg(row?.profile_picture);
            toggleEditModal();
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Delete" placement="top">
              <DeleteIcon style={{ color: "red", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Delete"
          onClick={() => {
            toggleDeleteModal();
            setSelectedRecord(row?._id);
          }}
        />,
      ],
    },
  ];

  useEffect(() => {
    getAllDesigners();
    // eslint-disable-next-line
  }, [paginator]);

  const toggleAddModal = () => setDisplayAddModal(!displayAddModal);
  const toggleEditModal = () => setDisplayEditModal(!displayEditModal);
  const toggleDeleteModal = () => setDisplayDeleteModal(!displayDeleteModal);

  const getAllDesigners = async ({ search = "" } = {}) => {
    try {
      const companyId = conUser?.user?.company_id?._id;
      const res = await DesignerRouter.getAll({
        page: paginator.page,
        pageSize: paginator.pageSize,
        type: "DESIGNER",
        companyId: companyId,
        search: search,
      });
      if (res?.data) {
        setDesigners(res?.data);
        setTotalCount(res?.pagination?.totalCount);
      }
    } catch (error) {
      console.log("Designers ", error);
    }
  };

  const addDesigner = () => {
    setName();
    setEmail();
    setPhone();
    setProfilePic();
    setProfileImg();
    setNameErr("");
    setEmailErr("");
    setPhoneErr("");
    toggleAddModal();
  };

  const createDesigner = async () => {
    try {
      const isValid = validate();
      if (!isValid) return null;

      const submitData = new FormData();

      submitData.append("name", name);
      submitData.append("email", email);
      submitData.append("phone", phone);
      if (profilePic) {
        submitData.append("profile_picture", profilePic);
      }
      submitData.append("role", "DESIGNER");
      submitData.append("state", "state");
      submitData.append("postalcode", "54000");
      submitData.append(`companyName`, "company_name");
      submitData.append("city", "city");
      submitData.append(`address`, "address");

      const res = await DesignerRouter.create(submitData);
      if (res.status !== 201 && res.status !== 200) {
        const msg =
          res?.error?.response?.data?.message || "An unknown Error occured";
        setEmailErr(msg);
      } else {
        toggleAddModal();
        setName("");
        setEmail("");
        setPhone("");
        setProfilePic("");
        setProfileImg("");
        getAllDesigners();
      }
    } catch (error) {
      console.log("Designers ", error);
    }
  };

  const updateDesigner = async () => {
    try {
      const isValid = validate(true);
      if (!isValid) return null;

      const updateData = new FormData();

      updateData.append("name", name);
      updateData.append("phone", phone);
      if (profilePic) {
        updateData.append("profile_picture", profilePic);
      }

      const res = await DesignerRouter.update(updateData, selectedRecord?._id);
      if (res) {
        toggleEditModal();
        setName("");
        setEmail("");
        setPhone("");
        setProfilePic("");
        setProfileImg("");
        getAllDesigners();
      }
    } catch (error) {
      console.log("Designers ", error);
    }
  };

  const removeDesigner = async () => {
    try {
      const id = selectedRecord;
      const res = await DesignerRouter.remove(id);
      if (res) {
        getAllDesigners();
        toggleDeleteModal();
      }
    } catch (error) {
      console.log("Designers ", error);
    }
  };

  const validate = (isUpdate = false) => {
    let isValid = true;
    if (!name) {
      setNameErr("name is required");
      isValid = false;
    }

    if (!email && !isUpdate) {
      setEmailErr("email is required");
      isValid = false;
    }

    if (!phone) {
      setPhoneErr("phone no is required");
      isValid = false;
    }

    return isValid;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImg(reader.result);
        setProfilePic(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debounceSearch = debounce(getAllDesigners, 500);

  const handleSearchInput = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    debounceSearch({ search });
  };

  return (
    <>
      <div className="mainContainer">
        {/* Add Dialog */}
        <Dialog open={displayAddModal} onClose={toggleAddModal}>
          <DialogTitle>Create Designer</DialogTitle>
          <DialogContent sx={{ minWidth: "500px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container>
                <Grid size={7}>
                  <CustomInput
                    id="name"
                    name="name"
                    title="Enter name"
                    type="text"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setNameErr("");
                    }}
                    required={nameErr.length > 0 ? true : false}
                    helperText={nameErr}
                    placeholder="enter name"
                    width="100%"
                  />
                  <CustomInput
                    id="email"
                    name="email"
                    title="Enter email"
                    type="text"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setEmailErr("");
                    }}
                    required={emailErr.length > 0 ? true : false}
                    helperText={emailErr}
                    placeholder="enter email"
                    width="100%"
                  />
                  <CustomInput
                    id="phone"
                    name="phone"
                    title="Enter phone"
                    type="text"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                      setPhoneErr("");
                    }}
                    required={phoneErr.length > 0 ? true : false}
                    helperText={phoneErr}
                    placeholder="enter phone"
                    width="100%"
                  />
                </Grid>
                <Grid size={5}>
                  <div className="imgBox">
                    <label>Profile Pic</label>
                    <img
                      className="img"
                      src={profileImg}
                      style={!profileImg ? { display: "none" } : {}}
                      alt="Profile Pic"
                    />
                    <input
                      type="file"
                      id="profilePic"
                      name="profilePic"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e)}
                    />
                    <button
                      onClick={() =>
                        document.getElementById("profilePic").click()
                      }
                    >
                      Upload Pic
                    </button>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleAddModal}>Cancel</Button>
            <Button onClick={() => createDesigner()}>Create</Button>
          </DialogActions>
        </Dialog>

        {/* Edit Dialog  */}
        <Dialog open={displayEditModal} onClose={toggleEditModal}>
          <DialogTitle>Edit Designer</DialogTitle>
          <DialogContent sx={{ minWidth: "500px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container>
                <Grid size={7}>
                  <CustomInput
                    id="name"
                    name="name"
                    title="Enter name"
                    type="text"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setNameErr("");
                    }}
                    required={nameErr.length > 0 ? true : false}
                    helperText={nameErr}
                    placeholder="enter name"
                    width="100%"
                  />
                  <CustomInputLabel title={"Email"} isRequired={false} />
                  <TextField
                    value={email}
                    id="email"
                    name="email"
                    fullWidth
                    disabled
                    variant="outlined"
                    sx={{ backgroundColor: "#E9ECEF" }}
                  />
                  <CustomInput
                    id="phone"
                    name="phone"
                    title="Enter phone"
                    type="text"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                      setPhoneErr("");
                    }}
                    required={phoneErr.length > 0 ? true : false}
                    helperText={phoneErr}
                    placeholder="enter phone"
                    width="100%"
                  />
                </Grid>
                <Grid size={5}>
                  <div className="imgBox">
                    <label>Profile Pic</label>
                    <img
                      className="img"
                      src={profileImg}
                      style={!profileImg ? { display: "none" } : {}}
                      alt="Profile Pic"
                    />
                    <input
                      type="file"
                      id="profilePic"
                      name="profilePic"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileChange(e)}
                    />
                    <button
                      onClick={() =>
                        document.getElementById("profilePic").click()
                      }
                    >
                      Upload Pic
                    </button>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleEditModal}>Cancel</Button>
            <Button onClick={() => updateDesigner()}>Update</Button>
          </DialogActions>
        </Dialog>

        {/* Delete Dialog */}
        <Dialog open={displayDeleteModal} onClose={toggleDeleteModal}>
          <DialogTitle>DELETE DESIGNER</DialogTitle>
          <DialogContent>
            Are you sure you want to disable/delete this designer?
            <h3 className="infoAlert">
              *All details will be lost and can not be recovered
            </h3>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleDeleteModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => removeDesigner()}
              variant="contained"
              sx={{ backgroundColor: "#FF7C1B" }}
            >
              Delete Designer
            </Button>
          </DialogActions>
        </Dialog>

        <Header></Header>
        <SideNav active="Designers" />
        <div className="contentBox">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1%",
              marginTop: "1%",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <TextField
              label="Search"
              margin="dense"
              variant="outlined"
              id="outlined-start-adornment"
              sx={{ m: 1, width: "25ch" }}
              onChange={handleSearchInput}
              value={searchTerm}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon></SearchIcon>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#27326A",
                width: "148px",
                height: "40px",
                textTransform: "none",
              }}
              onClick={() => addDesigner()}
            >
              <AddCircleOutlineIcon
                sx={{ marginRight: "10px", width: 18, height: 18 }}
              />
              Add Designer
            </Button>
          </Box>
          <DataGrid
            sx={{
              borderRadius: 3,
              border: 0,
              width: "100%",
              outline: "none", // Remove blue outline
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold !important",
                overflow: "visible !important",
                color: "#27326A",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-sortIcon": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none", // Remove blue outline
                },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none", // Remove blue outline
              },
              "& .MuiDataGrid-cell": {
                outline: "none", // Remove blue outline from cells
              },
              "& .MuiDataGrid-cell--textLeft": {
                textAlign: "left",
              },
              "& .MuiDataGrid-cell--textCenter": {
                textAlign: "center",
              },
              "& .MuiDataGrid-cell--textRight": {
                textAlign: "right",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "white",
                boxShadow: "0px 0px 30px #EDEEF4",
                outline: "none",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                outline: "none",
              },
              "& .name-cell-style": {
                color: "#566477",
                outline: "none",
              },
              "& .default-cell-style": {
                color: "#95A2B4",
                outline: "none",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "none",
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {},
            }}
            disableColumnMenu
            disableSelectionOnClick
            getRowId={(row) => row._id}
            columns={columns}
            rows={Designers}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterExcludeHiddenColumns: true,
                },
              },
              pagination: {
                paginationModel: { page: 0, pageSize: paginator.perPage },
              },
            }}
            paginationMode="server"
            rowCount={totalCount}
            onPaginationModelChange={(newPage) => {
              setPaginator({
                page: newPage?.page,
                perPage: newPage?.pageSize,
              });
            }}
            pageSizeOptions={[10]}
          ></DataGrid>
        </div>
      </div>
    </>
  );
};

export default Designer;
